import { render } from "./RegexForm.vue?vue&type=template&id=e9e344a4&ts=true"
import script from "./RegexForm.vue?vue&type=script&lang=ts"
export * from "./RegexForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__